import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=6e67c3e2&scoped=true"
import script from "./RadioButton.vue?vue&type=script&lang=ts"
export * from "./RadioButton.vue?vue&type=script&lang=ts"
import style0 from "./RadioButton.vue?vue&type=style&index=0&id=6e67c3e2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e67c3e2",
  null
  
)

export default component.exports